import { useEffect } from 'react'
import { trackWithOrigin } from 'components/FormNavigation/helpers/trackWithOrigin'
import { AmplitudeEvent } from 'utils/tracking/amplitude/amplitude.interface'

type UseDacAutoAdvanceParams = {
  dacWidgetState: string
  onNext: () => void
}

export const useDacAutoAdvance = ({
  dacWidgetState,
  onNext
}: UseDacAutoAdvanceParams): void => {
  useEffect(() => {
    if (dacWidgetState === 'success') {
      trackWithOrigin(AmplitudeEvent.OnDACSuccessAutoRedirect)
      onNext()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dacWidgetState])
}
